// extracted by mini-css-extract-plugin
module.exports = {"genericTooltip":"GenericTooltip_genericTooltip__ecwg9"};